import { Component, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { AlertService } from '../../services/alert.service';
import { HttpService } from '../../services/http.service';

@Component({
  selector: 'app-customer-document-modal',
  templateUrl: './customer-document-modal.component.html',
  styleUrls: ['./customer-document-modal.component.scss'],
})
export class CustomerDocumentModalComponent {
  @Input() user: any;
  @Input() requestAgain = false;
  /** Quando true, textos focados em pagamento/checkout; quando false, em completar cadastro. */
  @Input() isCheckoutContext = false;

  form: FormGroup;
  docType: 'CPF' | 'CNPJ' = 'CPF';
  errorMessage = '';
  loading = false;

  constructor(
    private modalCtrl: ModalController,
    private fb: FormBuilder,
    private alertService: AlertService,
    private httpSrvc: HttpService
  ) {
    this.form = this.fb.group({
      documentNumber: ['', Validators.required],
    });
  }

  get documentMask(): string {
    return this.docType === 'CPF' ? '000.000.000-00' : '00.000.000/0000-00';
  }

  selectType(type: 'CPF' | 'CNPJ') {
    this.docType = type;
    this.form.patchValue({ documentNumber: '' });
    this.errorMessage = '';
  }

  async submit() {
    this.errorMessage = '';
    const raw = (this.form.get('documentNumber')?.value || '').toString().replace(/\D/g, '');
    const expectedLen = this.docType === 'CPF' ? 11 : 14;
    if (raw.length !== expectedLen) {
      this.errorMessage = this.docType === 'CPF'
        ? 'Informe um CPF com 11 dígitos.'
        : 'Informe um CNPJ com 14 dígitos.';
      return;
    }
    if (!this.alertService.documentIsValid(this.docType, raw as any)) {
      this.errorMessage = 'O documento digitado é inválido. Verifique e tente novamente.';
      return;
    }
    this.loading = true;
    try {
      // Prefer the structured `number` field. `line_1` has inconsistent field
      // orders across the app, so `split(',')[0]` can be the street name instead
      // of the number. Fall back to line_1 only when `number` is absent (legacy).
      const addr = this.user?.address;
      const addressNumber = (addr?.number != null && addr?.number !== '')
        ? addr.number.toString().trim()
        : (addr?.line_1?.split(',')[0]?.trim() || '');
      const phoneStr = (this.user?.phone || '').toString().replace(/\D/g, '');
      const phoneNumber = phoneStr ? '+' + (phoneStr.length === 11 ? '55' + phoneStr : phoneStr) : '';
      const payload = {
        name: this.user.name,
        email: this.user.email,
        cpfCnpj: raw,
        mobilePhone: phoneNumber.replace('+55', ''),
        postalCode: this.user?.address?.zip_code || '',
        addressNumber,
        complement: this.user?.address?.compliment || '',
        externalReference: this.user.id,
      };
      const res: any = await this.httpSrvc.post('customer', payload).toPromise();
      this.user.customerId = res.id;
      // Salva o CPF/CNPJ no perfil do usuário (necessário para emissão de NF e
      // para não pedir o documento novamente nas próximas compras).
      this.user.cpfCnpj = raw;
      const storageItem = JSON.parse(localStorage.getItem('userDB') || '{}');
      if (storageItem.user) storageItem.user = this.user;
      else storageItem.user = this.user;
      localStorage.setItem('userDB', JSON.stringify(storageItem));
      // Persiste o documento no backend (perfil do usuário).
      const opts = this.httpSrvc.getOpts();
      if (opts && this.user.id) {
        try {
          await this.httpSrvc.put('user/' + this.user.id, { cpfCnpj: raw }, opts).toPromise();
        } catch (e) {
          console.error('[customer-document-modal] Falha ao salvar CPF no perfil do usuário', e);
        }
      }
      const customer = await this.httpSrvc.get('customer/' + this.user.customerId).toPromise();
      await this.modalCtrl.dismiss({ customer });
    } catch (err) {
      this.errorMessage = 'Não foi possível cadastrar. Tente novamente.';
    }
    this.loading = false;
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
